module.exports = __webpack_public_path__ + "img/zx13.97c63207.png";